/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Composables
import { createVuetify } from 'vuetify'
import { VDialogTransition } from 'vuetify/components'
import { markRaw, type App } from 'vue'
import { normalize } from '@/utils/accountability_filters'

const customFilter = (value: string, search: string) => normalize(value).includes(normalize(search))

const dropdownTransition = { component: markRaw(VDialogTransition) }

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export function setupVuetify(app: App, tableTranslations: { itemsPerPageText: string, noDataText: string, pageText: string }) {
  const vuetify = createVuetify({
    theme: {
      themes: {
        light: {
          colors: {
            primary: '#1B1B1B',
            secondary: '#2A3141',
            terciary: '#D2F7FF',
            success: '#16B889',
            error: '#FF3357',
            warning: '#92A6CC',
            orange: '#FB8C00',
            yellow: '#FFF3CD',
            formBackground: '#EAEEEF'
          },
        },
      },
    },
    defaults: {
      VTextField: {
        variant: "outlined",
        density: "comfortable",
        rounded: "lg"
      },
      VCombobox: {
        variant: "outlined",
        density: "comfortable",
        rounded: "lg",
        translate: "no",
        customFilter,
        transition: dropdownTransition
      },
      VAutocomplete: {
        variant: "outlined",
        density: "comfortable",
        rounded: "lg",
        transition: dropdownTransition
      },
      VSelect: {
        variant: "outlined",
        density: "comfortable",
        rounded: "lg"
      },
      VFileInput: {
        variant: "outlined",
        density: "comfortable",
        rounded: "lg"
      },
      VTextarea: {
        variant: "outlined",
        density: "comfortable",
        rounded: "lg"
      },
      VBtn: {
        rounded: "lg"
      },
      VSnackbar: {
        rounded: "lg"
      },
      VDataTableServer: {
        itemsPerPageText: tableTranslations.itemsPerPageText,
        noDataText: tableTranslations.noDataText,
        pageText: tableTranslations.pageText
      },
      VDataTable: {
        itemsPerPage: -1,
        itemsPerPageText: tableTranslations.itemsPerPageText,
        noDataText: tableTranslations.noDataText,
        pageText: tableTranslations.pageText
      },
      VCheckboxBtn: {
        color: "secondary"
      },
      VRating: {
        activeColor: "primary",
        size: 32,
        halfIncrements: true,
        hover: true,
        length: 5
      }
    }
  })

  return vuetify
}
